<template>
  <div class="background-wrapper" :style="{'margin-bottom': bgMargin}">
    <div class="background-wrapper__image" :style="[cssVars, { 'margin-top': bgMargin }]" :class="[{ 'background-wrapper__image--with-media': media }, classes[align]]">
      <slot name="background"/>
    </div>
    <div class="background-wrapper__content" :style="{ zIndex }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackgroundWrapper',
  props: {
    src: String,
    ext: { type: String, default: 'png' },
    media: { type: Boolean, default: true },
    size: { type: String, default: 'cover' },
    align: { type: String, default: 'bottom' },
    color: String,
    zIndex: { type: Number, default: 1 },
    bgMargin: { type: String, default: '0' }
  },
  computed: {
    classes () {
      return {
        top: 'background-wrapper__image--top',
        bottom: 'background-wrapper__image--bottom',
        left: 'background-wrapper__image--top-left'
      }
    },
    cssVars ({ src, ext, media, color }) {
      return {
        '--color': color,
        ...src && {
          '--src': color || `url(${require(`@/assets/${src}.${ext}`)})`,
          ...media && {
            '--src-768': color || `url(${require(`@/assets/${src}_768.${ext}`)})`,
            '--src-600': color || `url(${require(`@/assets/${src}_600.${ext}`)})`
          }
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.background-wrapper
  position: relative
  &__image
    display: flex
    flex-direction: column
    width: 100vw
    height: 100%
    position: absolute
    left: 50%
    transform: translateX(-50vw)
    z-index: 0
    background-size: cover
    background-repeat: no-repeat
    background-image: var(--src)
    background-color: var(--color)
    &--top-left
      background-position: top left
      background-size: auto !important
    &--top
      background-position: top center
    &--bottom
      background-position: bottom
    &--with-media
      background-size: cover
      +media-breakpoint-down(md)
        background-size: contain
        background-image: var(--src-768)
      +media-breakpoint-down(sm)
        background-image: var(--src-768)
      +media-breakpoint-down(xs)
        background-image: var(--src-600)
        background-size: contain
    &--contain
      background-size: contain

  &__content
    position: relative
    z-index: 1
</style>



// WEBPACK FOOTER //
// src/components/ui/BackgroundWrapperContain.vue